<!-- <mat-progress-bar mode="determinate" [value]=completedLimitations ></mat-progress-bar> -->
<!-- <div class="progress" *ngIf="(limitations | async)">
  <div class="progress-bar text-light progress-bar-striped progress-bar-animated"
  style="background-color: var(--secondary-color);" 
  role="progressbar" 
  [ngStyle]="{width:completedLimitationsPercentage + '%'}"
  [attr.aria-valuenow]="completedLimitationsPercentage"
  aria-valuemin="0"
  [attr.aria-valuemax]="valueMax">
  {{completedLimitations}}/{{limitationArray.length}}
  </div>
</div> -->

<!-- Le mie convinzioni limitanti-->
<mat-card *ngIf="(limitations | async)">
  <mat-card-header class="pb-2">
      <!-- <mat-progress-bar mode="determinate" [value]="completedLimitationsPercentage" color="accent"></mat-progress-bar> -->
      <div class="progress w-100">
        <div class="progress-bar text-light progress-bar-animated"
        style="background-color: var(--secondary-color);" 
        role="progressbar" 
        [ngStyle]="{width:completedLimitationsPercentage + '%'}"
        [attr.aria-valuenow]="completedLimitationsPercentage"
        aria-valuemin="0"
        [attr.aria-valuemax]="valueMax">
        {{completedLimitations}}/{{limitationArray.length}}
        </div>
      </div>
      <mat-card-title class="main-font mt-3">Le mie convinzioni limitanti</mat-card-title>
  </mat-card-header>
  <mat-card-content class="">

      <div class="list row m-2">
          <input type="text" class="col shadow-none" placeholder="Cosa ti limita?" [(ngModel)]="description">
          <button mat-mini-fab color="accent" class="fab-action my-auto" matTooltip="Aggiungi"
          (click)="editControl == false ? addLimitation(description) : ''">
            <mat-icon class="text-white">add</mat-icon>
          </button>
<!--           <button class="col-1 btn border-0" (click)="editControl == false ? addLimitation(description) : ''">
              <mat-icon>add</mat-icon>
          </button> -->
      </div>

      <div class="text-center m-4" *ngIf="incompletedArray.length < 1">
        <p class="main-font">Nessuna nuova limitazione</p>
      </div>

      <div *ngIf="limitations | async" cdkDropList class="list" (cdkDropListDropped)="editControl == false ? drop($event) : ''">  
        <div class="example-box row justify-content-between m-2" *ngFor="let limitation of (incompletedArray); index as i " cdkDrag>

              <div class="row col-10 justify-content-end">
                  <mat-checkbox class="col-1 me-3 my-auto" [checked]="limitation['is_checked'] == 1" (change)="updateLimitation(limitation.id, limitation.description, $event.checked)"></mat-checkbox>
                  <div class="row col-11" (click)="editControl == false ? enableEditMode(i) : ''" [matTooltip]="limitation['description']" [matTooltipDisabled]="limitation['description'].length <= 39">
                    <input class="col-12" type="text" [value]="limitation['description']" disabled="true" #des>
                  </div>
              </div>

            <div class="d-flex col-2 funRow">
                  
            <button class="col-4 btn text-primary border-0 me-2" (click)="editControl == false ? enableEditMode(i) : ''" #editBtn>
              <mat-icon>edit</mat-icon>
            </button>

            <button class="col-4 btn text-primary border-0 doneBtn me-2" (click)="updateLimitation(limitation['id'], des.value, limitation['checked'])" #doneBtn>
                <mat-icon>done</mat-icon>
            </button>

            <button class="col-4 btn text-danger border-0" (click)="editControl == false ? deleteLimitation(limitation['id']) : ''">
                <mat-icon>delete</mat-icon>
            </button>

            </div>

            <div class="position-relative">
              <div class="handle" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
              </div>
          </div>
        </div>

        <mat-accordion>
          <mat-expansion-panel class="mx-1 mt-5 mb-2">
              <mat-expansion-panel-header>
                  <mat-panel-title class="main-font">Limitazioni superate ({{completedLimitations + ' / ' + limitationArray.length}})</mat-panel-title>
              </mat-expansion-panel-header>
              
              <div class="text-center m-4" *ngIf="completedArray.length < 1">
                <p class="main-font">Nessuna limitazione superata</p>
              </div>
            
              <div class="example-box row m-2"  *ngFor="let limitation of (completedArray); index as i">

                  <div class="row col-11 justify-content-end">
                      <mat-checkbox class="col-1 me-3 my-auto" [checked]="limitation['is_checked'] == 1" (change)="updateLimitation(limitation.id, limitation.description, $event.checked)"></mat-checkbox>
                      <div class="row col-11">
                          <input class="col-12" type="text" [value]="limitation['description']" disabled="true">
                      </div>
                  </div>

              </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>




      <!-- <section *ngFor="let data of (profileData.value); index as i ">
          <mat-checkbox>{{data.my_inspirations}}</mat-checkbox>
      </section> -->
  </mat-card-content>
</mat-card>


      <!-- <ul>
            <li *ngFor="let item of todoItems" [class.completed]="item.completed" [class.editing]="item.editing">
              <div *ngIf="!item.editing" (dblclick)="startEditing(item)">
                {{ item.text }}
              </div>
              <input *ngIf="item.editing" type="text" [(ngModel)]="item.text" (blur)="finishEditing(item)">
              <button (click)="completeItem(item)">Complete</button>
              <button (click)="deleteItem(item)">Delete</button>
            </li>
          </ul> -->

